import React from "react";
import {useIntl} from "react-intl";
import Button from '@material-ui/core/Button';
import CircularProgress from "@material-ui/core/CircularProgress";
import {useStyles} from "./ButtonElementStyle";
import Icon from "@material-ui/core/Icon";


const ButtonElement = props => {

    const intl = useIntl();
    const classes = useStyles();
    const { labelId, label, loading, onSubmit, cssType, type = 'submit', disabled, icon, variant } = props;
    let buttonClass = classes.submit;

    if (cssType) {
        switch (cssType) {
            case 'cancel':
                buttonClass = classes.cancel;
                break;
            case 'delete':
                buttonClass = classes.delete;
                break;
            case 'edit':
                buttonClass = classes.edit;
                break;
            case 'deactive':
                buttonClass = classes.deactive;
                break;
            default:
                break;
        }
    }

    return (
        <Button
            variant={variant ? variant : "contained"}
            className={`${classes.button} ${buttonClass}`}
            onClick={onSubmit}
            disabled={disabled}
            type={type}
            startIcon={icon ? <Icon>{icon}</Icon> : ""}>
            {loading ? <CircularProgress size={14}/> : labelId ? intl.formatMessage({
                'id': labelId,
                'defaultMessage': label
            }) : label}
        </Button>
    )
};

export default ButtonElement;